import React, {Component} from 'react';
import Radium from 'radium';
import color from 'color';

class InputBar extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.adjustInputHeight();
		this.props.focusInputElement();
	}

	handleKeyPress(e) {

		if (e.key === 'Enter') {
			e.preventDefault();

			this.handleSubmit();
		}
	}

	handleSubmit() {
		const trimmedMessage = this.props.currentMessage.trim();

		if (trimmedMessage) {
			this.props.onSubmit(trimmedMessage);
		}
	}

	// Used to update current message
	handleTextChange(e) {
		this.props.updateMessage(e.target.value);
	}

	adjustInputHeight() {
		const input = this.messageInput;
		// explicit height needed to "reset" input height when it goes from tall to short
		input.style.height = "1px";

		input.style.height = (input.scrollHeight) + 1 + "px";
		this.props.setInputHeight(input.offsetHeight);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.currentMessage !== this.props.currentMessage) {
			this.adjustInputHeight();
		}
	}

	render() {
		return (
			<div id="input-bar" style={[
					styles.inputBar,
					this.props.pageState.get("loading") && styles.loading
				]} >
				<textarea id="message-input" 
					style={[styles.messageInput]} 
					autoComplete="off" 
					value={this.props.currentMessage}
					placeholder={this.props.client.get("isFrench") ? "Puis-je vous aider?" : "How can I help?"}
					onKeyPress={this.handleKeyPress.bind(this)}
					onChange={this.handleTextChange.bind(this)}
					ref={messageInput => this.messageInput = messageInput}
				>
				</textarea>
				<button 
					className="send-button" 
					style={[
						styles.sendButton,
						{color: this.props.client.get("tint")}
					]}
					onClick={this.handleSubmit.bind(this)}
				>
					{this.props.client.get("isFrench") ? "Envoyer" : "Send"}
				</button>
			</div>
		);	
	}
}


// STYLES

const styles = {
	inputBar: {
		position: 'fixed',
		bottom: '0',
		width: '100%',
		boxSizing: 'border-box',		
		transform: 'translateY(0)',
		transitionDuration: '0.15s',
		transitionTimingFunction: 'ease-in-out'
	},

	loading: {
		transform: 'translateY(100%)'
	},

	messageInput: {
		width: '100%',
		boxSizing: 'border-box',
	  	resize: 'none',
	  	minHeight: '46px',
	  	height: '46px',
	  	maxHeight: '120px',
		outline: 'none',
		padding: '12px 60px 12px 12px',
		resize: 'none',
		display: 'block',
		borderStyle: 'hidden',
		fontSize: '18px',
		overflowY: 'scroll',
		borderTop: '1px solid #e4e5ea',
		fontFamily: 'inherit',
		WebkitAppearance: 'none',
		borderRadius: '0',
		overflowStyle: 'none'
	},

	sendButton: {
	    height: '32px',
	    padding: '0',
	    lineHeight: '32px',
	    borderRadius: '9px',
	    outline: '0',
	    border: '0',
	    position: 'absolute',
	    right: '9px',
	    bottom: '7px',
	    fontWeight: '500',
	    background: 'none',
	    fontSize: '18px',
	    cursor: 'pointer'
	}
};


export default Radium(InputBar);


// WEBPACK FOOTER //
// ./src/components/InputBar.js